import React, { Component } from "react"
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap"
import { map } from "lodash"

//i18n
import { withTranslation } from "react-i18next"
import { languages } from "../../i18n/Translate"

class LanguageDropdown extends Component {
    constructor(props) {
        super(props)
        this.state = {
            menu: false,
            selectedLang: "en",
        }
    }

    componentDidMount() {
        const { i18n } = this.props;
        const currentLanguage = i18n.language;
        this.setState({ selectedLang: currentLanguage })
    }

    changeLanguageAction = lang => {
        const { i18n } = this.props;
        i18n.changeLanguage(lang)
        localStorage.setItem("lang", lang)
        this.setState({ selectedLang: lang })
    }

    toggle = () => {
        this.setState(prevState => ({
            menu: !prevState.menu,
        }))
    }

    render() {
        const { selectedLang, menu } = this.state

        return (
            <React.Fragment>
                <Dropdown isOpen={menu} toggle={this.toggle} className="d-inline-block">
                    <DropdownToggle className="btn header-item" tag="button">
                        <img
                            src={languages[selectedLang].flag}
                            alt="Skote"
                            height="16"
                            className=""
                        />
                    </DropdownToggle>
                    <DropdownMenu className="language-switch dropdown-menu-end">
                        {map(Object.keys(languages), key => (
                            <DropdownItem
                                key={key}
                                onClick={() => this.changeLanguageAction(key)}
                                className={`text-center notify-item ${selectedLang === key ? "active" : "none"
                                    }`}
                            >
                                <img
                                    src={languages[key].flag}
                                    alt="Skote"
                                    className="mx-2"
                                    height="12"
                                />

                                <span className="align-middle">
                                    {languages[key].label}
                                </span>
                            </DropdownItem>
                        ))}
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        )
    }
}

export default withTranslation("common")(LanguageDropdown)
